export default __webpack_public_path__ + "static/media/red_thumb.c042ca78.svg";